/**
 * The approved prototype's line icons (24px grid, 1.6 stroke, 18px by default): the rail's page icons, the arrow
 * affordance on forward actions, and the masthead's scope and refresh icons. Decorative: always aria-hidden, the
 * control they sit in carries the name.
 */
const PATHS = {
  home: "M3 11l9-8 9 8 M5 10v11h5v-7h4v7h5V10",
  today: "M4 5h16v15H4z M8 3v4 M16 3v4 M4 10h16 M8 14h3",
  list: "M9 5h11 M9 12h11 M9 19h11 M4 5h.01 M4 12h.01 M4 19h.01",
  check: "M9 12l2 2 5-6 M20 12v8H4V4h12",
  chart: "M4 3v17h17 M8 16v-4 M13 16V7 M18 16v-7",
  people: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M16 4a4 4 0 0 1 0 8 M22 21v-2a4 4 0 0 0-3-4 M9 3a4 4 0 1 0 0 8a4 4 0 0 0 0-8",
  cycle: "M20 7a9 9 0 0 0-15-2L2 8 M2 3v5h5 M4 17a9 9 0 0 0 15 2l3-3 M22 21v-5h-5",
  settings: "M12 8a4 4 0 1 0 0 8a4 4 0 0 0 0-8 M12 2v3 M12 19v3 M2 12h3 M19 12h3 M5 5l2 2 M17 17l2 2 M5 19l2-2 M17 7l2-2",
  help: "M12 2a10 10 0 1 0 0 20a10 10 0 0 0 0-20 M9 8a3 3 0 0 1 6 0c0 2-3 2-3 5 M12 17h.01",
  arrow: "M4 12h15 M14 6l6 6-6 6",
  search: "M10 3a7 7 0 1 0 0 14a7 7 0 0 0 0-14 M15 15l6 6",
  refresh: "M20 7a9 9 0 1 0 1 10 M20 2v6h-6",
  // AIC-511: the Platform bar's notifications bell.
  bell: "M6 9a6 6 0 0 1 12 0c0 6 2.5 8 2.5 8h-17S6 15 6 9 M10 20.5a2.2 2.2 0 0 0 4 0",
} as const;

export type LineIconName = keyof typeof PATHS;
export const LINE_ICONS = Object.keys(PATHS) as LineIconName[];

export function LineIcon({ name, className = "ipd-line-i" }: { readonly name: LineIconName; readonly className?: string }) {
  return <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d={PATHS[name]} /></svg>;
}

/** The trailing arrow on a forward action ("Review item →"): <button className="ipd-btn">Review item<ButtonArrow/></button>. */
export function ButtonArrow() {
  return <LineIcon name="arrow" className="ipd-arrow" />;
}
